import { NgModule } from '@angular/core';

import { CostPipe } from './pipes/cost.pipe';
import { PercentPipe } from './pipes/percent.pipe';

/**
 * Pipes for formatting value strings
 */
@NgModule({
  exports: [CostPipe, PercentPipe],
  declarations: [CostPipe, PercentPipe],
})
export class FormattingPipesModule {}
